module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"copied":"O link da seleção foi copiado para a área de transferência."}}')
  delete Component.options._Ctor
}
